import { Component, computed, ViewEncapsulation, inject } from '@angular/core';
import { IrisUserService } from '@iris/common/services/user.service';
import { AuthFacade } from '@iris/modules/auth/utils/auth.facade';
import { IrisMsalService } from '@iris/modules/msal/msal.service';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';

@Component({
  selector: 'iris-header-profile-info',
  templateUrl: './header-profile-info.component.html',
  styleUrls: ['./header-profile-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class IrisHeaderProfileInfoComponent  {
  private readonly userService = inject(IrisUserService);
  private readonly authFacade = inject(AuthFacade);
  private readonly msalService = inject(IrisMsalService);
  private readonly globalSandbox = inject(IrisGlobalSandbox);

  readonly baseUrl = computed(() => `/${this.globalSandbox.appAlias()}`);

  get me(): IdentUserI {
    return this.userService.me;
  }

  logoff(): void {
    this.authFacade.logout(true);
    this.msalService.removeActiveAccount();
  }
}
